// Pixel widths (fractions of the column's minSize), since percentage widths
// collapse to 0 inside the expand column's shrink-to-fit cell wrappers.
const SKELETON_WIDTH_FACTORS = [0.7, 0.45, 0.6, 0.5];

/** Width of a loading row's shimmer bar, varied by row and column. */
export function getSkeletonBarWidth({
    minSize,
    columnIndex,
    rowIndex,
}: {
    minSize: number;
    columnIndex: number;
    rowIndex: number;
}): number {
    const factorIndex =
        (columnIndex + rowIndex) % SKELETON_WIDTH_FACTORS.length;
    return Math.round(minSize * SKELETON_WIDTH_FACTORS[factorIndex]);
}
